<template>
  <el-dialog :title="$t('message.排期确认')" :visible.sync="innerVisible" width="30%" center>
    <div class="center">
      <span>{{ $t('message.somebody_apply_interview', { nickname: interview.custom_name }) }}</span>
      <div class="content">
        <el-date-picker
          :editable="false"
          type="datetime"
          :placeholder="$t('message.选择日期')"
          class="jm-input220"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm"
          default-time="10:00:00"
          v-model="interviewTime"
          @change="checkInterviewTime"
          :picker-options="pickerOptions"
        />
      </div>
      <el-alert :title="$t('message.该时间可以正常预约')" v-show="interviewTime && isOk" type="success"></el-alert>
      <div>
        <h4>{{ $t('message.面试方式') }}</h4>
        <el-radio-group v-model="form.interview_way">
          <el-radio
            border
            v-for="way in interviewWay"
            :label="way.value"
            :key="way.value"
          >{{ $i18n.local === 'ja' ? way.label_ja : way.label }}</el-radio>
        </el-radio-group>
      </div>
    </div>
    <span slot="footer" class="dialog-footer jm-tac">
      <el-button class="btn-close-dialog" type="primary" @click="closeDialog">{{ $t('message.取消') }}</el-button>
      <el-button class="btn-save-dialog" type="primary" :disabled="!isOk" @click="setInterviewTime">{{ $t('message.确认') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { interviewWay, interviewResult } from '../../dataset/interview';
import dialogMixin from './dialogMixin';

export default {
  mixins: [dialogMixin],
  props: {
    interview: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      form: {
        interview_way: '',
        interview_result: '',
        qualified_condition: '',
        interview_memo: '',
        asset_id: null,
        result_pdf: null
      },
      interviewWay,
      interviewResult,
      interviewTime: '',
      isOk: true,
      pickerOptions: {
        disabledDate(time) {
          return (
            time.getTime() < (Date.now() - 86400000)
          );
        }
      }
    };
  },
  methods: {
    closeDialog() {
      this.interviewTime = '';
      this.isOk = true;
      this.close();
    },
    /**
     * 检测面试时间
     */
    async checkInterviewTime(date) {
      if (!date) {
        return false;
      }
      try {
        await this.$http._post({
          url: '/interview/plan/checkInterviewTime',
          data: {
            date,
            schoolId: this.interview.school_id,
          }
        });
        this.isOk = true;
      } catch (e) {
        this.isOk = false;
        return false;
      }
    },
    /**
     * 设置面试时间
     */
    async setInterviewTime() {
      if (!this.interviewTime) {
        this.isOk = false;
        return false;
      }
      try {
        await this.$http._post({
          url: '/interview/plan/setInterviewTime',
          data: { id: this.interview.id, date: this.interviewTime, way: this.form.interview_way }
        });
        this.$message.success(this.$t('message.set_interview_success'));
        this.closeDialog();
        this.$emit('after-set', true);
      } catch (e) {
        this.isOk = false;
      }
    }
  },
  watch: {
    innerVisible(v) {
      if (v) {
        this.interviewTime = this.interview.interview_time;
      }
    }
  },
};
</script>
<style scoped>
.center {
  text-align: center;
}
.center h4 {
  font-size: 20px;
  padding: 25px;
}
.content {
  padding: 20px;
}
</style>
